import React from 'react'
import {
  ArrayInput,
  AutocompleteInput,
  BooleanInput,
  DateInput,
  SimpleFormIterator,
} from 'react-admin'
import { useKGetList } from 'services/hooks/useKGetList'
import { roles } from 'services/cfg/form'
import SingleImageInput from 'ui-shared/WrappedInputs/SingleImageInput'
import BudgetDateRangeInput from './BudgetDateRangeInput'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import CustomerFormCommon from 'ui-shared/FormComponents/CustomerFormCommon'
import { yupResolver } from '@hookform/resolvers/yup'
import { organizationVS } from 'services/validations/crm/organization'
import SetAllAddressCoverage from './AllowBolean'
import { countrySwitchFC } from 'services/geo-management'
import { useKArrayInput } from 'services/hooks/useKArrayInput'
import { Member } from 'services/api/entities/crm/organizations/types/internal/organization-model'
import KToolTip from 'ui-shared/KTooltip'
import KSelectInput from 'ui-shared/WrappedInputs/KSelectInput'

const style = { marginRight: '20px' }

const HasFullCoverageInput = ({ source }: { source?: string }) => {
  const { kGetSource } = useKArrayInput<Member>(source)
  return (
    <KToolTip title="form.fields.setAddressCoverageTooltip">
      <BooleanInput
        source={kGetSource('hasFullAddressCoverage')}
        label="form.fields.hasFullAddressCoverage"
      />
    </KToolTip>
  )
}

const ToggleCoverageInputITA = countrySwitchFC({ IT: HasFullCoverageInput })

const ToggleAllMembersCoverageITA = countrySwitchFC({
  IT: SetAllAddressCoverage,
})

const OrganizationForm: React.FC = () => {
  const choices = useKGetList('pmi')
  return (
    <CustomerFormCommon resolver={yupResolver(organizationVS)}>
      <SingleImageInput label="form.fields.organizationImage" />
      <BudgetDateRangeInput />
      <ToggleAllMembersCoverageITA />
      <ArrayInput source="members">
        <SimpleFormIterator inline disableReordering>
          <AutocompleteInput
            source="userId"
            optionText="email"
            label="form.fields.email"
            choices={choices}
            style={{ width: '256px' }}
          />
          <KSelectInput
            source="role"
            choices={roles}
            label="form.fields.role"
            style={style}
          />
          <KNumberInput
            source="budget"
            label="form.fields.budget"
            style={style}
          />
          <DateInput
            source="budgetDueDate"
            label="form.fields.dueDate"
            style={style}
          />
          <ToggleCoverageInputITA />
        </SimpleFormIterator>
      </ArrayInput>
    </CustomerFormCommon>
  )
}

export default OrganizationForm
